import {enableProdMode, provideZoneChangeDetection} from '@angular/core';

import {CanDeactivateGuard} from './app/guards/can-deactive.guard';
import {UsersService} from './app/services/users.service';
import {DialogService} from './app/services/dialog.service';
import {SearchService} from './app/services/search.service';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {RequestInterceptor} from './app/interceptors/RequestInterceptor';
import {ErrorStateMatcher} from '@angular/material/core';
import {InvalidErrorStateMatcher} from './app/util/InvalidErrorStateMatcher';
import {getFirestore, provideFirestore} from '@angular/fire/firestore';
import {bootstrapApplication} from '@angular/platform-browser';
import {provideAnimations} from '@angular/platform-browser/animations';
import {AppComponent} from './app/app.component';
import {environment} from './environments/environment';
import {provideRouter} from '@angular/router';
import {initializeApp, provideFirebaseApp} from '@angular/fire/app';
import {getAuth, provideAuth} from '@angular/fire/auth';
import {routes} from './app/app.routes';
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),CanDeactivateGuard,
        UsersService,
        DialogService,
        SearchService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RequestInterceptor,
            multi: true
        },
        {
            provide: ErrorStateMatcher,
            useClass: InvalidErrorStateMatcher
        },
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
        provideRouter(routes),
        provideFirebaseApp(() => initializeApp(environment.firebase)),
        provideAuth(() => getAuth()),
        provideFirestore(() => getFirestore()),
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: { appearance: 'outline' }
        }
    ]
}).catch(err => console.log(err));
